import Vue from "vue";
import { formatDate } from "@/helpers/date";

import formatDateTime from "./dateTimeFormatFilter";
import splitString from "./stringFilter";
import formatUserName from "./userNameFilter";
import bankAccountNumberFilter from "./bankAccountNumberFilter";
import yesNo from "./booleanFilter";
import { roundToTwoDecimals, floor } from "./numberFilter";

// TODO - Self registration of filters...
export default {
  install(vue: typeof Vue, options?: any): void {
    vue.filter("formatDate", formatDate);
    vue.filter("formatDateTime", formatDateTime);
    vue.filter("splitStringOnCapital", splitString);
    vue.filter("formatUserName", formatUserName);
    vue.filter("formatBankAccountNumber", bankAccountNumberFilter);
    vue.filter("yesNo", yesNo);
    vue.filter("roundToTwoDecimals", roundToTwoDecimals);
    vue.filter("floor", floor);
  }
};
